import { CommonModule } from '@angular/common';
import { ReportsComponent } from './Reports.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HttpClientModule } from '@angular/common/http';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RouterModule, Routes } from '@angular/router';
import { FileUploadModule } from 'primeng/fileupload';
import { FieldsetModule } from 'primeng/fieldset';
import { CalendarModule } from 'primeng/calendar';
import { SharedModule } from 'src/app/shared/shared.module';

import { RatingModule } from 'primeng/rating';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { StepsModule } from 'primeng/steps';
import {  CUSTOM_ELEMENTS_SCHEMA,NgModule } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { GalleriaModule } from 'primeng/galleria';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TableModule } from 'primeng/table';
import { GoogleMapsModule } from '@angular/google-maps';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
const routes: Routes = [
  { path: '', component: ReportsComponent },
];

@NgModule({
  declarations: [ReportsComponent],
  exports:[],
  imports: [DialogModule,
        CommonModule,ButtonModule,TagModule,TableModule,DropdownModule,
        SharedModule,
         StepsModule,
        FormsModule,
        PaginatorModule,
        GoogleMapsModule,
        InputSwitchModule,
        CalendarModule,
        FileUploadModule,
        RatingModule,
        ReactiveFormsModule,
        HttpClientModule,
        ProgressSpinnerModule,
        FieldsetModule,
        ToastModule,
        AccordionModule,
        CheckboxModule,
        InputTextModule,
        CardModule,
        GalleriaModule,
        TabViewModule,
        RouterModule.forChild(routes),
  ],
  providers: [HttpClientModule, MessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportsModule { }
